import React from 'react';
import { Change } from '../Change';
import { addCommasToNumber } from '../../../Utils/CommonUtils';

interface RATES_PROPS {
  image: string;
  rate: number;
  change: number;
  changeSign?: string;
  percentageChangeSign?: string;
  percentageChange?: number;
  gram: string;
}

export const GoldRates = ({
  image,
  rate,
  change,
  changeSign = '',
  percentageChangeSign = '',
  percentageChange = 0,
  gram,
}: RATES_PROPS): JSX.Element => {
  return (
    <>
      <div className="flex items-start gap-4 mr-6 sm:flex-col sm:border sm:border-[#EBEBEC] w-full sm:p-3 rounded-md sm:items-center sm:gap-2">
        <img
          src={image}
          alt=""
          width={56}
          height={56}
          className="w-14 sm:w-8"
        />
        <div className="flex flex-col items-start">
          <div className="flex gap-4 w-full items-center sm:justify-center">
            <div className="font-bold text-s-40 flex text-font-700 justify-center sm:text-s-24">
              ₹{addCommasToNumber(Math.floor(rate))}
            </div>
            <div className="flex flex-col align-middle">
              <Change sign={changeSign} change={Math.floor(change)} />
              <Change
                sign={percentageChangeSign}
                change={percentageChange}
                percentage={true}
              />
            </div>
          </div>

          <div className="px-2 py-1 bg-[#E0EDFE] text-[#0E4EA2] font-medium rounded-md sm:text-s-10 flex items-center gap-2">
            {` ₹/${gram} g`}{' '}
            <div className="hidden sm:block">
              <Change
                sign={changeSign}
                change={Math.floor(change)}
                hideOnMobile={false}
              />
              <Change
                sign={percentageChangeSign}
                change={percentageChange}
                percentage={true}
                hideOnMobile={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
